import { observer } from "mobx-react";
import RmaPageStore, { IRmaReceiveShipmentAction } from "../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaActionModalEmailSection from "../rma-action-modal/rma-action-modal-email-section";
import RmaActionModalLayout from "../rma-action-modal/rma-action-modal-layout";

interface IProps {
	rma: RmaPageStore;
	rmaAction: IRmaReceiveShipmentAction;
	onCloseClick: () => void;
}

const RmaActionReceiveShipmentModal: React.FC<IProps> = observer(({rma: _rma, rmaAction, onCloseClick}) => {
	const actionStore = rmaAction.store;

	const handleSubmit = () => {
		actionStore.submitAction(() => {
			rmsMixpanelStore.trackEvent("d&_shipment_received_button_confirmed");
			onCloseClick();
		});
	};

	const handleDismiss = () => {
		rmsMixpanelStore.trackEvent("d&_rma_keep_current_status");
		onCloseClick();
	};

	return (
		<RmaActionModalLayout
			rmaAction={rmaAction}
			onDismiss={handleDismiss}
			onSubmit={handleSubmit}
			isLoading={actionStore.isProcessing}
			isDisabled={actionStore.isProcessing}
		>
			<RmaActionModalEmailSection
				emailStore={actionStore}
				isDisabled={actionStore.isProcessing}
			/>
		</RmaActionModalLayout>
	);
});

export default RmaActionReceiveShipmentModal;
